"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ModalPortal = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _focusTrapReact = _interopRequireDefault(require("focus-trap-react"));
var _oxygenConfig = require("@8x8/oxygen-config");
var _oxygenConstants = require("@8x8/oxygen-constants");
var _oxygenOverlay = _interopRequireDefault(require("@8x8/oxygen-overlay"));
var _oxygenUtils = require("@8x8/oxygen-utils");
var _Modal = require("./Modal.props");
var _styled = require("../styled");
var _excluded = ["isVisible", "hasShadow", "shouldCloseOnEsc", "allowOutsideClick", "shouldCloseOnOverlayClick", "size", "width", "height", "onClose", "children", "shouldUseFocusTrap", "testId", "theme", "initialFocus", "title", "disableAutoFocus", "modalProps"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ModalPortal = function ModalPortal(_ref) {
  var isVisible = _ref.isVisible,
    hasShadow = _ref.hasShadow,
    shouldCloseOnEsc = _ref.shouldCloseOnEsc,
    allowOutsideClick = _ref.allowOutsideClick,
    shouldCloseOnOverlayClick = _ref.shouldCloseOnOverlayClick,
    size = _ref.size,
    width = _ref.width,
    height = _ref.height,
    onClose = _ref.onClose,
    children = _ref.children,
    _ref$shouldUseFocusTr = _ref.shouldUseFocusTrap,
    shouldUseFocusTrap = _ref$shouldUseFocusTr === void 0 ? true : _ref$shouldUseFocusTr,
    testId = _ref.testId,
    theme = _ref.theme,
    initialFocus = _ref.initialFocus,
    title = _ref.title,
    disableAutoFocus = _ref.disableAutoFocus,
    modalProps = _ref.modalProps,
    rest = _objectWithoutProperties(_ref, _excluded);
  /**
   * Request close action if the overlay is clicked and CloseOnOverlayClick is enabled
   */
  var onOverlayClick = (0, _react.useCallback)(function () {
    if (shouldCloseOnOverlayClick) {
      onClose();
    }
  }, [shouldCloseOnOverlayClick, onClose]);
  var onKeyDown = (0, _react.useCallback)(function (event) {
    if (shouldCloseOnEsc && event.keyCode === _oxygenConstants.keyCode.ESCAPE) {
      onClose();
    }
  }, [shouldCloseOnEsc, onClose]);
  var modalHeadingId = (0, _oxygenUtils.useId)();
  var setContentRef = function setContentRef(ref) {
    if (ref && !disableAutoFocus) {
      ref.focus();
    }
  };
  if (!isVisible) {
    return null;
  }

  // true if Modal has any other children other than ModalHeader & ModalFooter
  var modalHasContent = _react["default"].Children.toArray(children).some(function (child) {
    if (child && !child.type) {
      return true;
    }
    return child.type.name !== 'ModalHeader' && child.type.name !== 'ModalFooter';
  });
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_styled.Container, rest, /*#__PURE__*/_react["default"].createElement(_oxygenOverlay["default"], {
    onClick: onOverlayClick,
    onKeyDown: onKeyDown,
    tabIndex: "0"
  }), /*#__PURE__*/_react["default"].createElement(_focusTrapReact["default"], {
    active: shouldUseFocusTrap,
    focusTrapOptions: {
      allowOutsideClick: allowOutsideClick !== null && allowOutsideClick !== void 0 ? allowOutsideClick : shouldCloseOnOverlayClick,
      fallbackFocus: window.document.activeElement,
      initialFocus: initialFocus
    }
  }, /*#__PURE__*/_react["default"].createElement(_styled.Content, _extends({
    size: size,
    width: width,
    height: height,
    hasShadow: hasShadow,
    ref: setContentRef,
    onKeyDown: onKeyDown,
    tabIndex: "0",
    testId: testId,
    role: "dialog",
    "aria-modal": true,
    "aria-labelledby": modalHeadingId
  }, modalProps), _react["default"].Children.map(children, function (item) {
    var _item$type, _item$type2;
    // Pass in the modalHasContent prop only to ModalHeader & ModalFooter
    // Pass in the modalHeadingId as titleProps.id so there is
    // an association between aria-labelledby and headerTitle.id
    if ((item === null || item === void 0 ? void 0 : (_item$type = item.type) === null || _item$type === void 0 ? void 0 : _item$type.name) === 'ModalHeader' || (item === null || item === void 0 ? void 0 : (_item$type2 = item.type) === null || _item$type2 === void 0 ? void 0 : _item$type2.name) === 'ModalFooter') {
      var _item$type3;
      var updatedProps = {
        modalHasContent: modalHasContent
      };
      if ((item === null || item === void 0 ? void 0 : (_item$type3 = item.type) === null || _item$type3 === void 0 ? void 0 : _item$type3.name) === 'ModalHeader') {
        updatedProps.titleProps = {
          id: modalHeadingId
        };
      }
      return /*#__PURE__*/_react["default"].cloneElement(item, updatedProps);
    }
    return item;
  })))));
};
exports.ModalPortal = ModalPortal;
ModalPortal.propTypes = _Modal.propTypes;
ModalPortal.defaultProps = _Modal.defaultProps;
var _default = (0, _oxygenConfig.withTheme)(ModalPortal, 'modal');
exports["default"] = _default;